import React from 'react';

import { UncontrolledTooltip } from 'reactstrap';

const ShortWallet = ({ id, wallet, symbolNum = 5 }) => {
  const shortWallet = `${wallet.slice(0, symbolNum)}...${wallet.slice(-symbolNum)}`;
  const tooltipId = `wallet__addr${id}`;
  return (
    <div>
      <span id={tooltipId}>{shortWallet}</span>
      <UncontrolledTooltip placement="top" target={tooltipId} autohide={false}>
        {wallet}
      </UncontrolledTooltip>
    </div>
  );
};

export default ShortWallet;
